<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />

        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateActivity"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.group_of_activities')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @fillActivitiesGroupForm="fillActivitiesGroupForm"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.activities')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @fillActivitiesGroupForm="fillActivitiesGroupForm"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-12">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('common_words.group') }}:</strong>
                        </h6>
                        {{ activitiesGroupForm.group_name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('common_words.code') }}:</strong>
                        </h6>
                        {{ activitiesGroupForm.group_code }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('common_words.companies2') }}:</strong>
                        </h6>
                        <span
                          v-for="(
                            _, index
                          ) in activitiesGroupForm.businesses_names"
                          :key="index"
                        >
                          <el-tag type="info">
                            {{ activitiesGroupForm.businesses_names[index] }}
                          </el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong
                            >{{
                              $t('common_words.associated_profiles2')
                            }}:</strong
                          >
                        </h6>
                        <template
                          v-if="activitiesGroupForm.roles_name.length > 0"
                        >
                          <span
                            v-for="(
                              name, index
                            ) in activitiesGroupForm.roles_name"
                            :key="index"
                          >
                            <el-tag type="info">
                              {{ name }}
                            </el-tag>
                          </span>
                        </template>
                        <el-tag v-else type="warning">{{
                          $t('common_words.no_assigned')
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong
                            >{{ $t('common_words.associated_users2') }}:</strong
                          >
                        </h6>

                        <template
                          v-if="activitiesGroupForm.users_name.length > 0"
                        >
                          <span
                            v-for="(
                              name, index
                            ) in activitiesGroupForm.users_name"
                            :key="index"
                          >
                            <el-tag type="info">
                              {{ name }}
                            </el-tag>
                          </span>
                        </template>
                        <el-tag v-else type="warning">{{
                          $t('common_words.no_assigned')
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('common_words.activities') }}:</strong>
                        </h6>
                        <div
                          class="mb-2"
                          v-for="(activity, index) in activitiesGroupForm.name"
                          :key="index"
                        >
                          <el-tag
                            style="height: auto; color: black; width: 100%"
                            :type="
                              activitiesGroupForm.enable[index]
                                ? `info`
                                : `danger`
                            "
                          >
                            <div class="row pt-2">
                              <div class="col-12 col-sm-6 col-md-4 col-xl-3">
                                <h6 class="mb-2">
                                  <strong>{{ $t('common_words.name') }}</strong>
                                </h6>
                                <p
                                  class="col-text-ellipsis"
                                  v-tooltip.bottom="activity"
                                >
                                  {{ activity }}
                                </p>
                              </div>
                              <div class="col-12 col-sm-6 col-md-4 col-xl-1">
                                <h6 class="mb-2">
                                  <strong>{{ $t('common_words.code') }}</strong>
                                </h6>
                                <p>
                                  {{ activitiesGroupForm.code[index] }}
                                </p>
                              </div>
                              <div class="col-12 col-sm-6 col-md-4 col-xl-2">
                                <h6
                                  class="mb-2 col-text-ellipsis"
                                  :v-tooltip.bottom="
                                    $t('common_words.code_of_homologation')
                                  "
                                >
                                  <strong>{{
                                    $t('common_words.approved')
                                  }}</strong>
                                </h6>
                                <p>
                                  {{
                                    activitiesGroupForm.homologatedCode[index]
                                  }}
                                </p>
                              </div>
                              <div class="col-12 col-sm-6 col-md-4 col-xl-2">
                                <h6
                                  class="mb-2 col-text-ellipsis"
                                  v-tooltip.bottom="`Cod. de Centro de Costos`"
                                >
                                  <strong>Centro Costo</strong>
                                </h6>
                                <p>
                                  {{ activitiesGroupForm.costCenter[index] }}
                                </p>
                              </div>
                              <div class="col-12 col-sm-6 col-md-4 col-xl-2">
                                <h6 class="mb-2">
                                  <strong>{{
                                    $t('common_words.type_capture')
                                  }}</strong>
                                </h6>
                                <p style="text-transform: capitalize">
                                  {{ activitiesGroupForm.catchType[index] }}
                                </p>
                              </div>
                              <div class="col-12 col-sm-6 col-md-4 col-xl-2">
                                <h6 class="mb-2">
                                  <strong>{{
                                    $t('common_words.payment_unit')
                                  }}</strong>
                                </h6>
                                <p
                                  class="col-text-ellipsis"
                                  v-tooltip.bottom="
                                    activitiesGroupForm.payment_unit_names[
                                      index
                                    ]
                                  "
                                >
                                  {{
                                    activitiesGroupForm.payment_unit_names[
                                      index
                                    ]
                                  }}
                                </p>
                              </div>
                              <div class="col-12 col-sm-6 col-md-4 col-xl-2">
                                <h6 class="mb-2">
                                  {{ $t('common_words.production_unit') }}
                                </h6>
                                <p
                                  class="col-text-ellipsis"
                                  v-tooltip.bottom="
                                    activitiesGroupForm.production_unit_names[
                                      index
                                    ]
                                  "
                                >
                                  {{
                                    activitiesGroupForm.production_unit_names[
                                      index
                                    ]
                                  }}
                                </p>
                              </div>
                            </div>
                          </el-tag>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { showContinue, resetObjectProperties } from 'src/util/Util.js';
import FirstStep from './steps/FirstStep.vue';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SecondStep from './steps/SecondStep.vue';

export default {
  components: {
    FirstStep,
    SecondStep,
  },
  data() {
    return {
      title: '',
      activitiesGroupForm: {
        roles_id: [],
        users_id: [],
        activity_id: [],
        name: [],
        code: [],
        homologatedCode: [],
        costCenter: [],
        catchType: [],
        minimum: [],
        maximum: [],
        payment_unit: [],
        production_unit: [],
        enable: [true],
        roles_name: [],
        users_name: [],
      },
      wizardModel: {},
      example: {
        associations_ids: null,
        businesses_ids: null,
        names: null,
      },
      map: null,
      renderComponent: true,
    };
  },

  mixins: [MixinPermissions, MixinArcgisMap, mixinMasters, MixinMenu],

  methods: {
    cleanAllSteps() {
      this.$refs.firstStep.model = {
        ...this.$refs.firstStep.initialModel,
      };
      this.$refs.secondStep.model = {
        ...resetObjectProperties({ ...this.$refs.secondStep.model }),
        enable: [true],
        activity_number: 1,
        catchType: ['Finca'],
      };
      this.$refs.firstStep.availableRoles;
      this.$refs.firstStep.availableUsers;
      this.$refs.firstStep.updateSelectedBusinesses({
        ...this.$refs.firstStep.$refs.selectBusiness.model,
      });
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    onStepValidated(model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },

    fillActivitiesGroupForm(ref, others) {
      this.activitiesGroupForm = Object.assign(
        {},
        this.activitiesGroupForm,
        this.$refs[ref].model
      );

      if (others)
        this.activitiesGroupForm = Object.assign(
          {},
          this.activitiesGroupForm,
          others
        );
    },

    storeUpdateActivity() {
      this.showHideLoading(true);
      this.activitiesGroupForm.route = 'works/activitiesgroups';

      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.activitiesGroupForm.id = JSON.parse(
            sessionStorage.getItem('editForm')
          ).id;
          Axios.updateMaster(this.activitiesGroupForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/works/activitiesgroups',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.activitiesGroupForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/works/activitiesgroups',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },

  mounted() {
    this.selectedItemOnMenu('works');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    sessionStorage.removeItem('tableCode');
    this.deselectedItemOnMenu('works');
  },
};
</script>

<style>
.vue-form-wizard .wizard-icon-circle .wizard-icon-container {
  border-radius: 100% !important;
}
</style>
